import { round } from 'lodash';
import React from 'react';
import { MeasurementHelper } from '../../../lib/helpers/measurementHelper';

const FiverData: React.FC<{ helper: MeasurementHelper }> = ({ helper }) => {
  const measurementCount = helper.measurementCount;

  return (
    <p className="f4 tnum fw5 mv0">
      {round(
        helper.aggregate({
          aggregationType: 'average',
          seriesType: 'average'
        }),
        1
      )}
    </p>
  );
};

export default FiverData;
